// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-o_fm","advertDetailContactItem__link":"c-o_fn"};